import React from "react";
import Contact from "./components/Contact";
import Hero from "./components/Hero";
import Portfolio from "./components/Portfolio";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Clients from "./components/Clients";
import ErrorBoundary from "./components/reusables/ErrorBoundary";

function App() {
	return (
		<ErrorBoundary>
			<div>
				<Navbar />
				<Hero />
				<Services />
				<Portfolio />
				<Clients />
				<Testimonials />
				<Contact />
				<Footer />
			</div>
		</ErrorBoundary>
	);
}

export default App;
